/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingpendinghint2Inputs */

const en_crosspostingpendinghint2 = /** @type {(inputs: Crosspostingpendinghint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almost done - reopen the connection to pick a Page or account.`)
};

const de_crosspostingpendinghint2 = /** @type {(inputs: Crosspostingpendinghint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast fertig – öffne die Verbindung erneut, um eine Seite oder ein Konto auszuwählen.`)
};

/**
* | output |
* | --- |
* | "Almost done - reopen the connection to pick a Page or account." |
*
* @param {Crosspostingpendinghint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingpendinghint2 = /** @type {((inputs?: Crosspostingpendinghint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingpendinghint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingpendinghint2(inputs)
	return de_crosspostingpendinghint2(inputs)
});
export { crosspostingpendinghint2 as "crosspostingPendingHint" }